
import MetaTags from 'react-meta-tags';
import { useSelector } from 'react-redux';
import { getLocalizationLanguage } from 'src/modules/localization/localization.selector';

const DrawMetaTags = ({ description, imageUrl, title, pageUrl, keywords }) => {

    const lang = useSelector(getLocalizationLanguage);
    return (<MetaTags>
        <meta name="description" content={description} />
        <meta property="og:title" content={title} />
        <meta property="og:image" content={imageUrl} />

        <meta name="keywords" content={keywords} />
        <meta name="description" content={description} />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={title} />
        <meta name="twitter:description" content={description} />
        <meta name="twitter:image" content={imageUrl} />


        <meta property="og:title" content={title} />
        <meta property="og:url" content={pageUrl} />
        <meta property="og:type" content="website" />
        <meta property="og:locale" content={lang} />
        <meta property="og:description" content={description} />
        <meta property="og:image" content={imageUrl} />

    </MetaTags>)
}

export default DrawMetaTags